import { render, staticRenderFns } from "./ProductsImpuestos.vue?vue&type=template&id=4584bb94"
import script from "./ProductsImpuestos.vue?vue&type=script&lang=js"
export * from "./ProductsImpuestos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports